(function () {
  'use strict';

  var pendingCalls = [];
  var pollTimer = null;

  function clarityIsReady() {
    return typeof window.clarity === 'function';
  }

  function flushPendingCalls() {
    if (!clarityIsReady()) return false;

    while (pendingCalls.length) {
      var args = pendingCalls.shift();
      try {
        window.clarity.apply(window, args);
      } catch (error) {
        pendingCalls.unshift(args);
        return false;
      }
    }

    return true;
  }

  function startPolling() {
    if (pollTimer || clarityIsReady()) return;

    var attempts = 0;
    pollTimer = window.setInterval(function () {
      attempts += 1;
      if (flushPendingCalls() || attempts >= 80) {
        window.clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 250);
  }

  function sendClarity() {
    var args = Array.prototype.slice.call(arguments);

    if (clarityIsReady()) {
      if (pendingCalls.length && !flushPendingCalls()) {
        pendingCalls.push(args);
        startPolling();
        return;
      }
      try {
        window.clarity.apply(window, args);
        return;
      } catch (error) {
        pendingCalls.push(args);
        startPolling();
        return;
      }
    }

    pendingCalls.push(args);
    startPolling();
  }

  function trackEvent(name) {
    if (!name) return;
    sendClarity('event', name);
  }

  function setTag(key, value) {
    var normalized = String(value || '').trim().slice(0, 255);
    if (!key || !normalized) return;
    sendClarity('set', key, normalized);
  }

  function normalizedEventPart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 80);
  }

  function pageContext() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    var context = { type: 'general', entity: '' };
    var match = path.match(/^\/pages\/(programa|participante|sede)\/([^/]+)$/i);

    if (match) {
      context.type = match[1].toLowerCase();
      context.entity = decodeURIComponent(match[2]);
      return context;
    }

    if (document.querySelector('.workrol-agenda')) {
      context.type = 'agenda';
    }

    return context;
  }

  function setupPageTags() {
    var context = pageContext();
    setTag('cac_page_type', context.type);
    if (context.entity) setTag('cac_entity_handle', context.entity);

    if (context.type === 'programa') {
      setTag('cac_has_video', document.querySelector('.program-detail__video') ? 'yes' : 'no');
    }
  }

  function closestElement(target, selector) {
    var element = target && target.nodeType === 1 ? target : target && target.parentElement;
    return element && element.closest ? element.closest(selector) : null;
  }

  function trackClick(event) {
    var share = closestElement(event.target, '[data-share-network]');
    if (share) {
      trackEvent('cac_share_' + normalizedEventPart(share.getAttribute('data-share-network')));
      return;
    }

    if (closestElement(event.target, '[data-share-copy], [data-copy-program-url]')) {
      trackEvent('cac_share_copy');
      return;
    }

    var tab = closestElement(event.target, '[data-tab-target]');
    if (tab && closestElement(tab, '.workrol-agenda')) {
      var tabName = normalizedEventPart(tab.getAttribute('data-tab-target'));
      if (tabName === 'ponentes') tabName = 'participantes';
      trackEvent('cac_agenda_tab_' + tabName);
      return;
    }

    if (closestElement(event.target, '.workrol-agenda [data-day]')) {
      trackEvent('cac_agenda_filter_day');
      return;
    }

    if (closestElement(event.target, '.workrol-agenda [data-clear-filters]')) {
      trackEvent('cac_agenda_filter_clear');
      return;
    }

    if (closestElement(event.target, '[data-open-speaker]')) {
      trackEvent('cac_participant_modal_open');
      return;
    }

    if (closestElement(event.target, '[data-open-venue]')) {
      trackEvent('cac_venue_modal_open');
      return;
    }

    if (closestElement(event.target, '[data-google-calendar]')) {
      trackEvent('cac_calendar_google');
      return;
    }

    if (closestElement(event.target, '[data-apple-calendar]')) {
      trackEvent('cac_calendar_apple');
      return;
    }

    var link = closestElement(event.target, 'a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (/google\.[^/]+\/maps|maps\.google\.|maps\.app\.goo\.gl|goo\.gl\/maps/i.test(href)) {
      trackEvent('cac_maps_click');
      return;
    }

    if (/youtube\.com|youtu\.be/i.test(href)) {
      trackEvent('cac_youtube_click');
      return;
    }

    if (/wa\.me|whatsapp\.com/i.test(href)) {
      trackEvent('cac_share_whatsapp');
      return;
    }

    if (/facebook\.com\/sharer/i.test(href)) {
      trackEvent('cac_share_facebook');
      return;
    }

    if (/twitter\.com\/intent|x\.com\/intent/i.test(href)) {
      trackEvent('cac_share_x');
      return;
    }

    var destination;
    try {
      destination = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (/^\/pages\/programa\//i.test(destination.pathname) || destination.searchParams.has('programa')) {
      trackEvent('cac_program_open');
    } else if (/^\/pages\/participante\//i.test(destination.pathname) || destination.searchParams.has('participante')) {
      trackEvent('cac_participant_open');
    } else if (/^\/pages\/sede\//i.test(destination.pathname) || destination.searchParams.has('sede')) {
      trackEvent('cac_venue_open');
    }
  }

  function agendaRoot(control) {
    return closestElement(control, '.workrol-agenda');
  }

  function recordNoResults(control) {
    var root = agendaRoot(control);
    if (!root) return;

    window.setTimeout(function () {
      var empty = root.querySelector('.workrol-agenda__empty');
      var isEmpty = Boolean(empty && !empty.hidden);

      if (isEmpty && root.getAttribute('data-cac-no-results') !== 'true') {
        root.setAttribute('data-cac-no-results', 'true');
        trackEvent('cac_agenda_no_results');
      } else if (!isEmpty) {
        root.removeAttribute('data-cac-no-results');
      }
    }, 450);
  }

  function trackFilterChange(event) {
    var filter = closestElement(event.target, '.workrol-agenda [data-filter]');
    if (!filter) return;

    var filterName = normalizedEventPart(filter.getAttribute('data-filter')) || 'general';
    trackEvent(filter.value ? 'cac_agenda_filter_' + filterName : 'cac_agenda_filter_clear');
    recordNoResults(filter);
  }

  var searchTimers = new WeakMap();

  function trackSearch(event) {
    var input = closestElement(event.target, '.workrol-agenda__search');
    if (!input) return;

    var previousTimer = searchTimers.get(input);
    if (previousTimer) window.clearTimeout(previousTimer);

    var timer = window.setTimeout(function () {
      if (String(input.value || '').trim()) {
        trackEvent('cac_agenda_search');
      }
      recordNoResults(input);
      searchTimers.delete(input);
    }, 700);

    searchTimers.set(input, timer);
  }

  function observeProgramVideo() {
    var video = document.querySelector('.program-detail__video');
    if (!video || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (!entries[i].isIntersecting || entries[i].intersectionRatio < 0.5) continue;
        trackEvent('cac_program_video_view');
        observer.disconnect();
        break;
      }
    }, { threshold: [0.5] });

    observer.observe(video);
  }

  function initialize() {
    setupPageTags();
    observeProgramVideo();
    document.addEventListener('click', trackClick, true);
    document.addEventListener('change', trackFilterChange, true);
    document.addEventListener('input', trackSearch, true);
    flushPendingCalls();
    startPolling();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
